import { Pipe, PipeTransform } from "@angular/core";
import { AppConstants } from "../constants/constants";

@Pipe({
  name: "colorPipe",
})
export class ColorIndicatorPipe implements PipeTransform {
  transform(color: string, tutorView: boolean = false): string {
    switch (color) {
      case AppConstants.COLOR_GREEN:
        color = AppConstants.GREEN_TABLE_MESSAGE;
        break;
      case AppConstants.COLOR_AMBER:
        color = AppConstants.AMBER_TABLE_MESSAGE;
        break;
      case AppConstants.COLOR_RED:
        color = AppConstants.RED_TABLE_MESSAGE;
        break;
      default:
        color = AppConstants.BLANK;
        break;
    }

    color = (color != AppConstants.BLANK) ? tutorView ? [color, AppConstants.RAG_RESULT_TUTOR].join(AppConstants.SINGLE_SPACE) : color : color;

    return color;
  }
}
